




















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';

@Component
export default class PersonalSettings extends Vue {
    private status!: string;
    private username!: string;
    private displayName!: string;
    private password!: string;


    private data() {
        return {
            status: '',
            username: '',
            displayName: '',
            password: '',
        };
    }

    private created() {
        this.$store.state.mobileSidebarVisible = false;
        this.$store.state.menuVisible = false;
    }

}
